import { createBrowserRouter, RouterProvider } from 'react-router';
import { AppProviders } from '@/app/providers/AppProviders';
import { routes } from '@/routes/router';

/**
 * The browser router is created here rather than in routes/router.tsx because
 * createBrowserRouter reads `document`; keeping it out of the shared routes
 * module lets the SSR prerenderer import `routes` without crashing.
 *
 * When the route table HMR-updates, invalidate this module so the router is
 * rebuilt — otherwise new paths (e.g. /order-manager) keep showing NotBuilt.
 */
const router = createBrowserRouter(routes);

if (import.meta.hot) {
  import.meta.hot.accept(() => {
    import.meta.hot?.invalidate();
  });
}

/**
 * Root application shell: global providers wrapped around the router. The
 * browser entry (main.tsx) mounts this; the prerenderer builds its own static
 * tree in entry-server.tsx.
 */
export default function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}
